<div class="playlist-song">
  <div class="song-button">
    <button (click)="playSong()" *ngIf="!song.isPlaying" class="song-button--play">
      <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g>
          <path
            d="M50 25C50 31.6304 47.3661 37.9893 42.6777 42.6777C37.9893 47.3661 31.6304 50 25 50C18.3696 50 12.0107 47.3661 7.32233 42.6777C2.63392 37.9893 0 31.6304 0 25C0 18.3696 2.63392 12.0107 7.32233 7.32233C12.0107 2.63392 18.3696 0 25 0C31.6304 0 37.9893 2.63392 42.6777 7.32233C47.3661 12.0107 50 18.3696 50 25ZM21.2188 15.9156C20.9851 15.7493 20.7102 15.6504 20.4241 15.63C20.1381 15.6095 19.8519 15.6681 19.5969 15.7995C19.3419 15.9308 19.1281 16.1298 18.9787 16.3746C18.8293 16.6195 18.7502 16.9007 18.75 17.1875V32.8125C18.7502 33.0993 18.8293 33.3805 18.9787 33.6254C19.1281 33.8702 19.3419 34.0692 19.5969 34.2005C19.8519 34.3319 20.1381 34.3905 20.4241 34.37C20.7102 34.3496 20.9851 34.2507 21.2188 34.0844L32.1562 26.2719C32.3588 26.1273 32.5239 25.9365 32.6378 25.7153C32.7517 25.4941 32.8111 25.2488 32.8111 25C32.8111 24.7512 32.7517 24.5059 32.6378 24.2847C32.5239 24.0635 32.3588 23.8727 32.1562 23.7281L21.2188 15.9156Z"
            fill="white"/>
        </g>
      </svg>
    </button>
    <button (click)="pauseSong()" *ngIf="song.isPlaying" class="song-button--pause">
      <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g>
          <path
            d="M50 25C50 31.6304 47.3661 37.9893 42.6777 42.6777C37.9893 47.3661 31.6304 50 25 50C18.3696 50 12.0107 47.3661 7.32233 42.6777C2.63392 37.9893 0 31.6304 0 25C0 18.3696 2.63392 12.0107 7.32233 7.32233C12.0107 2.63392 18.3696 0 25 0C31.6304 0 37.9893 2.63392 42.6777 7.32233C47.3661 12.0107 50 18.3696 50 25Z"
            fill="black"/>
          <g>
            <rect x="17" y="15" width="4" height="20" rx="2" fill="white"/>
            <rect x="29" y="15" width="4" height="20" rx="2" fill="white"/>
          </g>
        </g>
      </svg>
    </button>
  </div>
  <div class="song-meta">
    <h6>{{ song.song.artist }}</h6>
    <p>{{ song.song.title }}</p>
  </div>
  <div class="song-timeline">
    <audio #player
           (loadedmetadata)="onLoadedMetadata()"
           (timeupdate)="onTimeUpdate()"
           (play)="onPlay()"
           (pause)="onPause()"
           (ended)="onEnded()"
           (progress)="onProgress()">
      <source [src]="getAudioUrl(song)" type="audio/mp3">
      Your browser does not support the audio element.
    </audio>

    <span class="song-time">{{ getDuration() }}</span>

    <div #timeline class="song-timeline--line"
         (click)="onTimelineClick($event)"
         (mousedown)="onTimelineMouseDown($event)"
         (touchstart)="onTimelineTouchStart($event)">
      <div class="song-timeline--buffered" *ngIf="song.isPlaying || isDragging" [ngStyle]="getBufferedStyle()"></div>
      <div class="song-timeline--played" [ngStyle]="getPlayedStyle()">
        <div class="song-timeline--handle" *ngIf="song.isPlaying || isDragging"></div>
      </div>
    </div>
  </div>
</div>
